import { useFaq } from './useFaq';

function Faq({ faqs,title }) {
    const {
        openIndex,
        toggle } = useFaq(faqs);

    return (
        <section id='Faq' className="bg-[#ff6c00] py-16 px-6">
            <div className="max-w-4xl mx-auto text-center">
                <span className="inline-block bg-orange-100 text-orange-600 text-xs font-semibold rounded-full px-4 py-1 mb-4">
                    Ajuda
                </span>
                <h2 className="text-white text-2xl md:text-3xl font-semibold text-gray-800 mb-10">
                    {title}
                </h2>
            </div>

            <div className="max-w-4xl mx-auto divide-y divide-gray-200">
                {faqs.map((faq, index) => (
                    <div key={index} className="py-4">
                        <button
                            onClick={() => toggle(index)}
                            className="w-full flex justify-between items-center text-left text-gray-800 font-medium hover:text-orange-600 transition-colors"
                        >
                            <span className='text-white font-bold'>{faq.question}</span>
                            <svg
                                className={`w-5 text-white h-5 transition-transform duration-200 ${openIndex === index ? "rotate-180" : "rotate-0"
                                    }`}
                                fill="none"
                                stroke="currentColor"
                                strokeWidth="2"
                                viewBox="0 0 24 24"
                            >
                                <path d="M19 9l-7 7-7-7" />
                            </svg>
                        </button>
                        {openIndex === index && (
                            <div className="mt-3 text-white">{faq.answer}</div>
                        )}
                    </div>
                ))}
            </div>
        </section>
    );
}

export default Faq;